import { Location } from '@angular/common';
import { Component, ComponentFactoryResolver, ComponentRef, HostListener, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ImageTransform } from 'ngx-image-cropper';
import { debounceTime, finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import { StorageFunctions } from '../../general/storage';
import { getErrorMessage, markFormGroupTouched, mergeArray, roundCorrectly, setArrayFormValue, setFieldFormValue, setFormValue, tratarStringXml, scrollIntoView } from '../../general/utils';
import { UtilFunctions } from '../../general/utils-service';
import { IAliquotaICMS } from '../../model/IAliquotaICMS';
import { IndicadorProducao } from '../../model/IndicadorProducao';
import { OrigemMercadoria } from '../../model/OrigemMercadoria';
import { TipoCodigosProdutosANP } from '../../model/TipoCodigosProdutosANP';
import { TipoServicoISSQN } from '../../model/TipoServicoISSQN';
import { TipoSituacaoTributariaCOFINS } from '../../model/TipoSituacaoTributariaCOFINS';
import { TipoSituacaoTributariaIPI } from '../../model/TipoSituacaoTributariaIPI';
import { TipoSituacaoTributariaPIS } from '../../model/TipoSituacaoTributariaPIS';
import { TipoTributacaoServicoISSQN } from '../../model/TipoTributacaoServicoISSQN';
import { AliquotasIcmsService } from '../../services/aliquotasIcms.service';
import { AlmoxarifadosService } from '../../services/almoxarifados.service';
import { ClassificacoesFiscaisService } from '../../services/classificacoes-fiscais.service';
import { DataService } from '../../services/data.service';
import { EstadosService } from '../../services/estados.service';
import { MessageService } from '../../services/message.service';
import { OcupacaoAgendaService } from '../../services/ocupacaoAgenda.service';
import { TabelasPrecoService } from '../../services/tabelas-preco.service';
import { UnidadesEmpresaParametrosService } from '../../services/unidades-empresa-parametros.service';
import { UnidadesEmpresaService } from '../../services/unidades-empresa.service';
import { UnidadesMedidaService } from '../../services/unidades-medida.service';
import { EdicaoMascaras } from '../../shared/EdicaoMascaras';
import { AbrirModalComponent } from '../../shared/abrir-modal/abrir-modal.component';
import { BaseFactoryComponent } from '../../shared/base-factory/base-factory.component';
import { ItensService } from './../../services/itens.service';
import { LinhasProdutosService } from './../../services/linhas-produtos.service';
import { TipoItensService } from './../../services/tipo-itens.service';
import { fadeInOutTranslate } from './../../shared/elements/animation';
import { ItensComposicaoComponent } from './itens-composicao/itens-composicao.component';
import { SegmentosService } from '../../services/segmentos.service';
import { firstValueFrom, lastValueFrom, Subject } from 'rxjs';
import { AutosService } from '../../services/autos.service';
import { CustomValidators } from '../../general/validations/custom-validators';
import { DimTabswipeComponent } from '../../shared/dim-tabswipe/dim-tabswipe.component';
import { DimRadioGroupOptionsViewModel } from '../../shared/dim-radio-group/dim-radio-group.component';
import { ReducoesICMSInterestaduaisService } from '../../services/reducoesICMSInterestaduais.service';
import { TipoDestaqueICMS } from '../../model/TipoDestaqueICMS';
import { CodigosBeneficiosFiscaisService } from '../../services/codigos-beneficios-fiscais.service';
import { BalancasServiceV2 } from '@servicesv2';
import { ItensFornecedoresService } from '../../services/itens-fornecedores.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { IBSCBSService } from '../../services/ibscbs.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { CodigosNBS } from '../../model/CodigosNBS';

@Component({
  selector: 'app-produtos-detalhes',
  templateUrl: './produtos-detalhes.component.html',
  styleUrls: ['./produtos-detalhes.component.css'],
  animations: [fadeInOutTranslate]
})
export class ProdutosDetalhesComponent extends BaseFactoryComponent implements OnInit {
  TipoDestaqueICMS = TipoDestaqueICMS; // Para usar no template
  public dados: any = [];
  public dadosDetalhes: any = [];
  public loading = {
    request: false,
    unidadesMedida: false,
    almoxarifados: false,
    linhaProdutos: false,
    cest: false,
    horarios: false,
    salvando: false,
    deletando: false,
    classificacaoFiscal: false,
    tabelasPreco: false,
  };
  constructor(
    private resolver: ComponentFactoryResolver,
    private builder: FormBuilder,
    private classificService: ClassificacoesFiscaisService,
    private unidadesMedidaService: UnidadesMedidaService,
    private parametrosService: UnidadesEmpresaParametrosService,
    private tiposItensService: TipoItensService,
    private aliquotasIcmsService: AliquotasIcmsService,
    location: Location,
    private almoxarifadoService: AlmoxarifadosService,
    private linhaService: LinhasProdutosService,
    route: ActivatedRoute,
    private itensService: ItensService,
    private classificacoesService: ClassificacoesFiscaisService,
    message: MessageService, storage: StorageFunctions,
    utilFunctions: UtilFunctions,
    private unidadesEmpresaService: UnidadesEmpresaService,
    private tabelasPrecoService: TabelasPrecoService,
    private ocupacaoAgendaService: OcupacaoAgendaService,
    private estadoService: EstadosService,
    private balancasService: BalancasServiceV2,
    private dataService: DataService,
    private router: Router,
    private segmentosService: SegmentosService,
    private autosService: AutosService,
    private reducoesICMSInterestaduaisService: ReducoesICMSInterestaduaisService,
    private codigosBeneficiosFiscaisService: CodigosBeneficiosFiscaisService,
    private itensFornecedoresService: ItensFornecedoresService,
    private ibscbsService: IBSCBSService,
  ) {
    super(route, utilFunctions, message, storage, location);
  }

  get tabs() {
    if (this.form.get('servicoProduto').value === 'S') {

      if (this.horarioInicial && this.horarioFinal) {
        return ['Geral', 'Impostos', 'Agenda'];
      }

      return ['Geral', 'Impostos'];
    }

    if (this.comercioVeiculos) {
      return ['Geral', 'Impostos', 'Específicos', 'Autos', 'Logística', 'Tabelas de preço', 'RelacionamentosCustomTab', 'Fotos'];
    }

    return ['Geral', 'Impostos', 'Específicos', 'Logística', 'Tabelas de preço', 'RelacionamentosCustomTab', 'Fotos'];
  }

  imageChangedEvent: any = '';
  croppedImage: any = '';
  tooltipImagem = '';


  optionsAliquota = {
    prefix: '', precision: 2
  };

  tabelasPrecosColunas = [
    { label: 'Nome', col: 'tabelasPreco.nome', hide: false },
    { label: 'Preço', col: 'preco', currency: true, hide: false }
  ];

  tabelaItensComposicaoColunas = [
    { label: 'Item filho', col: 'descricaoItem', customTmpl: true },
    { label: 'Quantidade', col: 'quantidade', customTmpl: true }
  ];

  tabelaRelacionamentosColunas = [
    { label: 'Cód. Item de Entrada', col: 'referenciaItem' },
    { label: 'Nome', col: 'nome' },
    { label: 'Fornecedor', col: 'fornecedor.nome' }
  ];

  tiposBaseCalculoPISCOFINS = [
    { value: 'V', label: 'Sobre o Valor de Venda' },
    { value: 'L', label: 'Sobre o Valor de Lucro' }
  ];

  selectIndicadorEstoque = [
    { id: 0, descricao: '0 - Estoque de propriedade do informante e em seu poder' },
    { id: 1, descricao: '1 - Estoque de propriedade do informante e em posse de terceiros' },
    { id: 2, descricao: '2 - Estoque de propriedade de terceiros e em posse do informante' },
  ];

  unidadesMedida: object[];
  form: FormGroup;
  formAuto: FormGroup;
  horariosForm: FormGroup;
  obterClassificacoesForm: FormGroup;
  origens: object[] = new OrigemMercadoria().ListarOrigem();
  tipoItens: object[];
  cests = [];
  aliquotas: IAliquotaICMS[] = [];
  situacaoTributariaIPI: object[] = this.mapTipoDescricao(new TipoSituacaoTributariaIPI().Listar(), true);
  situacaoTributariaPis: object[] = this.mapTipoDescricao(new TipoSituacaoTributariaPIS().List(), true);
  situacaoTributariaCofins: object[] = this.mapTipoDescricao(new TipoSituacaoTributariaCOFINS().Listar(), true);
  tipoTributacaoServicos: object[] = this.mapTipoDescricao(new TipoTributacaoServicoISSQN().Listar());
  servicosISSQN: object[] = this.mapTipoDescricao(new TipoServicoISSQN().Listar());
  servicosNBS: object[] = this.mapCodigoDescricao(new CodigosNBS().Listar());
  indicadorProducao: object[] = new IndicadorProducao().listar();
  edicaoMascaras = EdicaoMascaras;
  unidadesEmpresa;
  itemInicial;
  campoAtual = { campo: null, value: null };
  aliquotasSelecionadas = null;
  unidadesEmpresaParametrosGerais;
  selecionaAliquota = false;
  permiteCodigoDuplicado: boolean;
  comercioVeiculos = false;
  estadosMap: any[];
  stICMSProEmprego: object[] = [];

  @ViewChild('itensFornecedoresSelect', { static: false }) itensFornecedoresSelect: NgSelectComponent;
  adicionandoItemFornecedor = false;
  filtroItensFornecedor = new Subject<string>();
  itensFornecedor = [];
  selectOptions = {
    opSelecionado: 1,
    options: [
      { value: 'Código', checked: false },
      { value: 'Descrição', checked: false },
      { value: 'EAN', checked: false },
      { value: 'Código Entrada', checked: false }
    ]
  };
  formItemFornecedor: FormGroup;

  @ViewChild('itensComposicaoContainer', { read: ViewContainerRef, static: false }) itensComposicaoContainer: ViewContainerRef;
  @ViewChild('appTab', { static: false }) appTab: DimTabswipeComponent;
  itensComposicaoComponentRef: ComponentRef<ItensComposicaoComponent>;
  id: number;
  tabelasPrecosCadastradas = [];
  tabelasPrecoDisponiveis = [];
  tabelasPrecoSelecionada = null;
  tabelasPrecoSelecionadaPreco = null;
  tabelasPrecoError = null;
  precisaoQuantidade = 0;
  precisaoPreco = 0;
  codigoEmUso = false;

  horarioInicial = null;
  horarioFinal = null;
  data;

  tipoProdutoANPMap: object[] = this.mapTipoDescricao(new TipoCodigosProdutosANP().listar());
  almoxarifados: object[];
  linhas: object[];
  @ViewChild('abrirModal', { static: true }) abrirModal: AbrirModalComponent;

  estoqueForm;

  itensFotos = [];
  itensFotosCarregadas = false;
  itensFotosCarregando = false;

  @ViewChild('imageCropper', { static: false }) imageCropper: any;
  enviarImagem = false;
  imagemParaEditar: any = undefined;
  mostraBotoesProduto = true;
  imageCropperImage: any = '';
  imageCropperImageType: any = '';
  canvasRotation = 0;
  transform: ImageTransform = {};
  listReducoesICMSInterestaduais = [];
  formReducao: FormGroup;
  indexReducao: number = null;
  @Input() dentroModal = false;
  @Input() appendTo = 'body'; // Para uso do componente dentro de modal
  @Input() preencherDados: any = null;

  codigoANPOptions: DimRadioGroupOptionsViewModel[] = [
    { label: 'Gás', value: 0 },
    { label: 'ICMS Monofásico', value: 1 },
    { label: 'Outros', value: 2 },
  ];

  icmsMonoEnabled = true;
  get icmsMonoDisabled() {
    return !this.icmsMonoEnabled;
  }

  // types define qual das opções de codigoANPOptions devem exibir determinado ICMS
  icmsMonoCSTsOptions: DimRadioGroupOptionsViewModel[] = [
    { label: 'ICMS02', value: 1, types: [0, 1] }, // 02
    { label: 'ICMS15', value: 2, types: [0, 1] }, // 15
    { label: 'ICMS53', value: 3, types: [0, 1] }, // 53
    { label: 'ICMS61', value: 4, types: [0, 1] }, // 61
  ];

  codigosCreditoPresumido = [];
  cstIBSCBS = [];
  listaCClassTribIBSCBS = [];
  cClassTribIBSCBS = [];
  private observer: MutationObserver;

  get icmsMonoCSTsOptionsFilter() {
    return this.icmsMonoCSTsOptions.filter(item => item.types.includes(this.form.get('combGLP').value));
  }

  async getId() {
    this.id = this.route.snapshot.params.id;

    if (this.cadastroFactory) {
      this.id = this.factoryId;
    }

    if (!this.novoCadastro) {
      this.buscaDadosProduto();
      return;
    }

    const clone = this.dataService.id;
    if (clone[0] !== 0) {
      this.buscaDadosProduto(clone[0], true);
      return;
    }

    if (this.cadastroFactory) {
      this.form.get('nome').setValue(this.newName);

      if (this.preencherDados) {
        this.form.get('nome').setValue(this.preencherDados.nome);
        this.form.get('classificacaoFiscalID').setValue(this.preencherDados.classificacaoFiscalID);
        this.form.get('almoxarifadoPadraoId').setValue(this.preencherDados.almoxarifadoPadraoId);
        this.form.get('unidadeMedidaID').setValue(this.preencherDados.unidadeMedidaID);
        this.form.get('extipi').setValue(this.preencherDados.extipi);
        this.form.get('codigoANP').setValue(this.preencherDados.codigoANP);
        this.form.get('uTrib').setValue(this.preencherDados.uTrib);
        this.form.get('fatorConversaoUtrib').setValue(this.preencherDados.fatorConversaoUtrib);
        this.form.get('custoCompra').setValue(this.preencherDados.custoCompra);
        this.form.get('ipiSituacaoTributaria').setValue(this.preencherDados.cstIpi);
        this.form.get('aliquotaipi').setValue(this.preencherDados.aliquotaIpi);
        this.form.get('pisSituacaoTributaria').setValue(this.preencherDados.cstPis);
        this.form.get('pis').setValue(this.preencherDados.aliquotaPis);
        this.form.get('cofinsSituacaoTributaria').setValue(this.preencherDados.cstCofins);
        this.form.get('cofins').setValue(this.preencherDados.aliquotaCofins);
        this.form.get('tipoItemid').setValue(this.preencherDados.tipoItemid);
        this.form.get('precoSaida').setValue(this.preencherDados.precoSaida);
      }
    }

    await this.buscarIBSCBS();
  }

  async ngOnInit() {
    this.form = this.builder.group({
      id: 0,
      referenciaItem: ['', Validators.required],
      nome: ['', Validators.required],
      descricaoComplementar: '',
      unidadeMedidaID: [null, Validators.required],
      uTrib: null,
      cambioId: null,
      precoSaida: null,
      custoCompra: null,
      cEAN: '',
      cEANTributavel: '',
      indicadorProducao: null,
      precoMaximoConsumidor: null,
      codigoAnvisa: null,
      codigoANP: null,
      combGLP: 2,
      comb_pGNn: null,
      comb_pGNi: null,
      comb_pGLP: null,
      comb_vPart: null,
      tipoCombustivel: null,
      aliquotaFixaAdRem: null,
      indiceMisturaBio: null,
      percRedAdRem: null,
      percDifMono: null,
      aliquotaRetidaAdRem: null,
      cnpjFabricante: null,
      almoxarifadoPadraoId: null,
      linhaId: null,
      unidade: null,
      inativo: false,
      servicoProduto: [null, Validators.required],
      tabelasPrecoProduto: new FormArray([]),
      estoqueMinimo: null,
      itensComposicao: new FormArray([]),
      cargaMinutosAgenda: null,
      data: null,
      cliente: null,
      gerarCodigoAutomatico: true,
      autoID: null,
      codigoBeneficioFiscal: null,
      cCredPresumido: null,
      pCredPresumido: null,
      destacarICMSItemDiferido: false,
      cUFOrig: null,
      pOrig: null,
      quantidadePadraoVolume: null,
      validadeEmDias: null,
      fatorConversaoUtrib: [null, Validators.min(0.0001)],
      balancaId: null,
      codigoBalanca: null,
      percentualDiferimento: null,
      STICMS_ProEmprego: null,
      STIPI_ProEmprego: null,
      percentualDif_ProEmprego: null,
      cBenef_ProEmprego: null,
      cstIBSCBS: null,
      cClassTribIBSCBS: null,
      percDiferimentoIBSCBS: null,
      localizacaoEstoque: null,
    });

    this.setFormValidators();

    this.formAuto = new FormGroup({
      id: new FormControl(0),
      estadoId: new FormControl(null, [Validators.required, CustomValidators.validaProdutoAuto]),
      renavam: new FormControl(null, [Validators.required, CustomValidators.validaProdutoAuto]),
      placa: new FormControl(null, [Validators.required, CustomValidators.validaProdutoAuto]),
      marca: new FormControl(null, [Validators.required, CustomValidators.validaProdutoAuto]),
      chassi: new FormControl(null),
      potencia: new FormControl(null),
      combustivel: new FormControl(null),
      motor: new FormControl(null),
      capacidade: new FormControl(null),
      categoria: new FormControl(null),
      modelo: new FormControl(null, [Validators.required, CustomValidators.validaProdutoAuto]),
      ano_Fabricacao_Modelo: new FormControl(null, [Validators.required, CustomValidators.validaProdutoAuto]),
      cor: new FormControl(null, [Validators.required, CustomValidators.validaProdutoAuto])
    });

    this.formReducao = new FormGroup({
      id: new FormControl(0),
      estadoId: new FormControl(null, [Validators.required]),
      percentualRedutorICMS: new FormControl(null, [Validators.required]),
      observacoes: new FormControl(null, [Validators.maxLength(200)]),
    });

    this.verificaCasasDecimais();
    this.possuiComercioVeiculos();

    this.parametrosService.getParametrosGerais().subscribe(res => {
      this.horarioInicial = res.horaInicialAgenda;
      this.horarioFinal = res.horaFinalAgenda;
      this.permiteCodigoDuplicado = res.cadastraNovoItemImportacaoXML;
      this.form.get('cargaMinutosAgenda').setValue(res.cargaMinutosAgenda);
    });

    this.servicoProduto.valueChanges.subscribe(value => {
      const chaves = [];
      const listaP: any[] = [
        { name: 'classificacaoFiscalID', validations: [Validators.required] },
        { name: 'peso' },
        { name: 'pesoBruto' },
        { name: 'quantidadePadraoVolume', value: 0 },
        { name: 'codigoCESTID' },
        { name: 'aliquotaicmsid', validations: [Validators.required] },
        { name: 'substituicaoTributaria', value: false },
        { name: 'tipoDestaqueICMS', value: 0 },
        { name: 'ipiSituacaoTributaria' },
        { name: 'aliquotaipi' },
        { name: 'extipi', validators: [Validators.minLength(2), Validators.maxLength(3)] },
        { name: 'ipiValorUnitario' },
        { name: 'pisSituacaoTributaria' },
        { name: 'pis' },
        { name: 'pisValorUnitario' },
        { name: 'cofinsSituacaoTributaria' },
        { name: 'cofins' },
        { name: 'cofinsValorUnitario' },
        { name: 'retemPisPassep', value: false },
        { name: 'retemCofins', value: false },
        { name: 'retemInss', value: false },
        { name: 'abaterICMSBasePISCOFINS', value: false },
        { name: 'tipoBaseCalculoPISCOFINS' },
        { name: 'cnaeFiscal', value: '' },
        { name: 'aliquotaICMSCompra' },
        { name: 'origemMercadoria', value: 0, validations: [Validators.required] },
        { name: 'tipoItemid', validations: [Validators.required] },
        { name: 'saldoInicialEstoque' },
        { name: 'motivoMovimentacaoEstoqueID' },
        { name: 'indicadorTipoEstoque' },
        { name: 'observacoes', validations: [Validators.maxLength(1000)] },
        { name: 'uTrib' },
        { name: 'codigoBeneficioFiscal' },
        { name: 'cCredPresumido' },
        { name: 'pCredPresumido' },
        { name: 'fatorConversaoUtrib' },
        { name: 'percentualDiferimento' },
      ];

      const listaS: any[] = [
        { name: 'codigoissqn' },
        { name: 'codigoNBS' },
        { name: 'aliquotaissqn' },
        { name: 'formaTributacaoServicoISSQN' },
        { name: 'retemCsll', value: false },
        { name: 'retemIss', value: false },
        { name: 'retemIR', value: false },
      ];

      if (value === 'P') {
        listaP.forEach(element => {
          this.form.addControl(element.name, new FormControl(element.value, element.validations));
          chaves.push(element.name);
        });


        listaS.forEach(element => {
          this.form.removeControl(element.name);
        });

        if (this.novoCadastro) {
          this.form.get('unidadeMedidaID').setValue(null);
        }

      } else {
        listaS.forEach(element => {
          this.form.addControl(element.name, new FormControl(element.value, element.validations));
          chaves.push(element.name);
        });

        listaP.forEach(element => {
          this.form.removeControl(element.name);
        });

        if (this.novoCadastro) {
          this.form.get('unidadeMedidaID').setValue(339642);
        }
      }

      this.form.updateValueAndValidity();

      if (!this.novoCadastro && this.itemInicial && this.itemInicial.servicoProduto == null) {
        Object.keys(this.form.controls).forEach(element => {
          if (chaves.indexOf(element) > -1 && this.form.get(element)) {
            this.form.get(element).setValue(this.itemInicial[element]);
          }
        });
      }
      this.aliquotasSelect();
      this.selecionaDadosPadroesCadastros();
      // if (this.loading.unidadesMedida === false) {
      //   this.form.get('unidadeMedidaID').setValue(339642);
      // }
    });
    this.form.get('servicoProduto').setValue('P');

    this.formConsulta = 'consultaProdutos';
    this.getId();

    if (this.novoCadastro) {
      this.messageService.info('Selecione o tipo de item para iniciar o cadastro', 8000);
    }

    this.carregaAlmoxarifados();
    this.carregaLinhaProdutos();
    this.carregaUnidadesMedida();
    this.carregaTabelasPreco();
    this.carregaCodigoCreditoPresumido();

    this.tiposItensService.get()
      .subscribe(result => {
        this.tipoItens = result;
      });

    const aiquotaIcmsPromisse = this.carregaAliquotaIcms();
    this.adicionaInformacoesVideo(this.abrirModal, 'CadastroProduto');

    const parametrosGeraisPromisse = new Promise((resolve, reject) => {
      this.parametrosService.getParametrosGerais()
        .subscribe(res => {
          this.unidadesEmpresaParametrosGerais = res;
          this.verificaCasasDecimais();
          resolve({});
        }, error => {
          Swal('Erro', 'Ocorreu um erro ao obter os parâmetros gerais: ' + error.msg.errors[0], 'error');
        });
    });

    if (this.form.get('servicoProduto').value === 'P') {
      Promise.all([aiquotaIcmsPromisse, parametrosGeraisPromisse]).then(() => {
        if (this.unidadesEmpresaParametrosGerais.aliquotaIcmsPadraoID) {
          let list = this.aliquotas;

          if (this.form.get('substituicaoTributaria')?.value === true
            || this.form.get('tipoDestaqueICMS')?.value !== TipoDestaqueICMS.NORMAL
            || [1, 4].includes(this.unidadesEmpresa?.crt)) {
            list = [];
            this.aliquotas.forEach((element) => {
              if (element && element.percentualRedutorICMS === 0
                || element.percentualRedutorICMS == null
                || element.percentualRedutorICMS === undefined) {
                list.push(element);
              }
            });
          }

          if (list.length > 0) {
            const found = list.map(e => (e as any).id).indexOf(this.unidadesEmpresaParametrosGerais.aliquotaIcmsPadraoID);
            if (found > -1 && this.form.get('aliquotaicmsid') && (this.form.get('aliquotaicmsid').value || 0) == 0) {
              this.form.get('aliquotaicmsid').setValue(this.unidadesEmpresaParametrosGerais.aliquotaIcmsPadraoID);
              this.campoAtual = {
                campo: 'aliquotaicmsid',
                value: this.unidadesEmpresaParametrosGerais.aliquotaIcmsPadrao.percentualRedutorICMS
              };
            }
          }
        }
      });
    }

    this.horariosForm = new FormGroup({
      horariosPorData: new FormArray([])
    });

    this.estadoService.getDateFuso().subscribe(date => {
      this.data = new Date(date);
      this.calcularHorarios();
    });

    this.estadoService.get()
      .subscribe(res => {
        this.estadosMap = res;
      });

    this.carregaBalancas();

    this.buscarReducoesVinculadas();

    this.filtroItensFornecedor.pipe(debounceTime(1000)).subscribe(filtro => {
      this.itensFornecedor = [];
      this.buscaItensFornecedor(filtro, this.selectOptions.options[this.selectOptions.opSelecionado].value);
    });

    this.form.get('cstIBSCBS').valueChanges.subscribe(res => {
      this.cClassTribIBSCBS = this.listaCClassTribIBSCBS.filter(x => x.cst === this.form.get('cstIBSCBS').value);

      const cClassTrib = this.form.get('cClassTribIBSCBS').value;
      if (cClassTrib && !this.cClassTribIBSCBS.some(x => x.cClassTrib === cClassTrib)) {
        this.form.get('cClassTribIBSCBS').setValue(null);
      }

      if (res) {
        this.form.get('cClassTribIBSCBS').setValidators([Validators.required]);
      } else {
        this.form.get('cClassTribIBSCBS').setValidators([]);
      }
      this.form.get('cClassTribIBSCBS').updateValueAndValidity();
    });

    this.observarTema();
  }

  balancas: any[];
  async carregaBalancas() {
    this.balancas = await this.balancasService.getAsPromise();
  }

  tipoDestaqueICMSChanged() {
    this.form.get('codigoBeneficioFiscal').setValue(null);
    const tipoDestaqueICMS = this.form.get('tipoDestaqueICMS').value;
    if (tipoDestaqueICMS !== TipoDestaqueICMS.DIFERIDO) {
      this.form.get('destacarICMSItemDiferido').setValue(false);
      this.form.get('percentualDiferimento').setValue(null);
    }
  }

  itensFotosGerarURL() {
    return new Promise((resolve) => {
      this.itensService.gerarFotosURL(this.itensFotos)
        .subscribe(listaFotosURL => {
          const x = listaFotosURL;
          this.itensFotos = this.itensFotos.map(item => {
            const f = listaFotosURL.find(foto => foto.id == item.id);
            return { ...item, src: f.url };
          });
          this.itensFotosCarregadas = true;
          resolve({});
        });
    });
  }

  async possuiComercioVeiculos() {
    try {
      this.comercioVeiculos = await firstValueFrom(this.segmentosService.possuiComercioVeiculos());
    } catch (error) {
      console.error(getErrorMessage(error));
    }
  }

  async handleImageGaleryTabChange() {
    if (!this.itensFotos.length) {
      this.enviarImagem = true;
      this.mostraBotoesProduto = false;
    }

    this.imagemParaEditar = undefined;
    if (!this.itensFotosCarregadas && this.itensFotos && this.itensFotos.length) {
      this.itensFotosCarregando = true;
      await this.itensFotosGerarURL();
      this.itensFotosCarregando = false;
    }
    return;
  }

  onTabChange(index: any) {
    if (index == 6) {
      this.handleImageGaleryTabChange();
    } else {
      this.mostraBotoesProduto = true;
    }
    return;
  }

  isNullOrUndefined(obj): boolean {
    return obj === null || obj === undefined;
  }

  get horarios() {
    const formArray = (this.horariosForm.get('horariosPorData') as FormArray);
    if (!this.isNullOrUndefined(formArray)) {
      const horarios = (formArray.controls).filter(x => x.value.data === this.data);
      if (!this.isNullOrUndefined(horarios)) {
        if (horarios.length > 0) { return (horarios[0] as FormGroup).controls.horarios; }
      }
    }
  }

  selecionaDadosPadroesCadastros() {
    if (this.novoCadastro && this.unidadesEmpresa && [1, 4].includes(this.unidadesEmpresa.crt)) {
      if (this.form.get('servicoProduto').value === 'P') {
        this.form.get('ipiSituacaoTributaria').setValue('52');
        this.form.get('pisSituacaoTributaria').setValue('99');
        this.form.get('cofinsSituacaoTributaria').setValue('99');
      }
    }
  }

  verificaCasasDecimais() {
    this.parametrosService.getParametrosGerais().subscribe(params => {
      this.precisaoPreco = params.casasDecimaisPreco ? params.casasDecimaisPreco : 2;
      this.precisaoQuantidade = params.precisaoQuantidade ? params.precisaoQuantidade : 2;
    });
  }

  get servicoProduto() {
    return this.form.get('servicoProduto') as FormControl;
  }

  getDynamicOption(name) {
    return this.form.get(name) as FormControl;
  }

  carregaAliquotaIcms() {
    return new Promise((resolve, reject) => {
      this.unidadesEmpresaService.getUnidadeEmpresa()
        .subscribe(res => {
          this.unidadesEmpresa = res;
          this.selecionaDadosPadroesCadastros();
          this.aliquotasIcmsService.getAliquotasIcms()
            .subscribe(result => {
              this.aliquotas = result;
              this.aliquotasSelect();
              resolve({});
            });
        });

    });
  }

  carregaUnidadesMedida() {
    this.loading.unidadesMedida = true;
    this.unidadesMedidaService.get()
      .pipe(finalize(() => this.loading.unidadesMedida = false))
      .subscribe(response => {
        this.unidadesMedida = response;
      });
  }

  carregaAlmoxarifados() {
    this.loading.almoxarifados = true;
    this.almoxarifadoService.get()
      .pipe(finalize(() => this.loading.almoxarifados = false))
      .subscribe(response => {
        this.almoxarifados = response;
      });
  }

  carregaLinhaProdutos() {
    this.loading.linhaProdutos = true;
    this.linhaService.get()
      .pipe(finalize(() => this.loading.linhaProdutos = false))
      .subscribe(response => {
        this.linhas = response;
      });
  }

  mapTipoDescricao(situacoes, removeId = false) {
    return situacoes.map(element => {
      if (removeId) {
        return { id: element.tipo, name: element.descricao };
      }
      return { id: element.tipo, name: element.tipo + ' - ' + element.descricao };
    });
  }

  mapCodigoDescricao(situacoes, removeId = false) {
    return situacoes.map(element => {
      if (removeId) {
        return { id: element.codigo, name: element.descricao };
      }
      return { id: element.codigo, name: element.codigo + ' - ' + element.descricao };
    });
  }

  mapCEST(array) {
    return array.map(val => {
      return { id: val.id, name: (val.codigo ? val.codigo + ' - ' : '') + val.descricao };
    });
  }

  async changeNCM(classificacaoFiscalID: number) {
    if (!classificacaoFiscalID) {
      this.cests = [];
      this.setFieldFormValue('codigoCESTID', null);
      return;
    }

    try {
      this.loading.request = true;

      const response = await firstValueFrom(this.classificService.getById(classificacaoFiscalID));
      const ncm = response.classificacaoFiscal;

      this.buscaCestItem(ncm);
      if (ncm) {
        const unidadeTributavel = await firstValueFrom(this.classificService.getUnidadeTributavel(ncm));
        this.form.get('uTrib').setValue(unidadeTributavel);
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.loading.request = false;
    }
  }

  async buscaCestItem(ncm: string) {
    try {
      this.loading.cest = true;
      const response = await firstValueFrom(this.classificService.getCest(ncm));
      if (response && response.length > 0) {
        this.cests = this.mapCEST(response);
        if (!this.cests.find(value => value.id === this.getFormValue('codigoCESTID'))) {
          this.setFieldFormValue('codigoCESTID', null);
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.loading.cest = false;
    }
  }

  voltar(consultaSozinho = true) {
    this.storage.setConsultarSozinho('consultaProdutos', consultaSozinho);
    this.location.back();
  }

  async buscaDadosProduto(id = this.id, clone = false) {
    this.itensService.getById(id)
      .subscribe(async response => {
        if (response?.data === null) {
          this.messageService.error('Produto não encontrado.', 5000);
          this.router.navigate(['/suprimentos/cadastros/produtos']);
          return;
        }
        this.itemInicial = response;
        this.form.get('servicoProduto').setValue(response.servicoProduto); // Tem que definir ServicoProduto antes do setFormValue, pois são adicionados/removidos campos do Form.
        setFormValue(this.form, response);
        if (!this.form.get('tipoDestaqueICMS')?.value) {
          this.form.get('tipoDestaqueICMS')?.setValue(TipoDestaqueICMS.NORMAL);
        }
        this.atualizaListaTabelasPrecosDisponiveis();
        this.configuraItensFotos(response.itensFotos);
        this.carregaAuto();
        if (!response.combGLP && response.combGLP !== 0) {
          this.form.get('combGLP').setValue(2);
        }
        this.form.get('gerarCodigoAutomatico').setValue(false);
        this.form.get('STICMS_ProEmprego').setValue(response.sticmS_ProEmprego);
        this.form.get('STIPI_ProEmprego').setValue(response.stipI_ProEmprego);

        await this.buscarIBSCBS();

        if (clone) {
          setTimeout(() => {
            this.form.get('id').setValue(0);
            this.form.get('ipiSituacaoTributaria').setValue(response.ipiSituacaoTributaria);
            this.form.get('pisSituacaoTributaria').setValue(response.pisSituacaoTributaria);
            this.form.get('cofinsSituacaoTributaria').setValue(response.cofinsSituacaoTributaria);
            this.form.get('unidadeMedidaID').setValue(response.unidadeMedidaID);
            this.form.get('gerarCodigoAutomatico').setValue(true);
            this.form.get('referenciaItem').setValue('');
            this.atualizaArraysClone();
          });
        }
      });
  }

  buscaNovoCodigo() {
    this.itensService.getSequenciaCodigo()
      .subscribe(res => {
        this.form.get('referenciaItem').setValue(res);
      });
  }

  salvarFotosProduto(itemData: any) {
    if (!itemData.itemId) {
      return;
    }

    const removeSrcEBlob = (_foto: any) => {
      const foto = { ..._foto };
      delete foto.src;
      delete foto.srcBlob;
      return foto;
    };

    const formData = new FormData();
    formData.append('itemId', itemData.itemId);
    for (const imagem of this.itensFotos) {
      if (imagem.srcBlob) {
        formData.append('file', imagem.srcBlob, imagem.nome);
      }
    }

    formData.append('itensFotos', JSON.stringify(this.itensFotos.map(removeSrcEBlob)));

    this.itensService.uploadFotoProduto(formData)
      .subscribe(res => { return; });
    return;
  }

  async salvar() {
    this.loading.horarios = true;

    if (this.validaValoresGLP()(this.form)) {
      const tab = this.tabs.indexOf('Específicos');
      if (tab !== -1) {
        this.appTab.setTab(tab);
      }
    }

    // Verifica se há dados preenchidos na aba Autos
    const isAutoFormFilled = Object.keys(this.formAuto.controls).some(key => !!this.formAuto.get(key).value);
    if (this.form.valid) {
      if (isAutoFormFilled && !this.formAuto.valid) {
        this.appTab.setTab(3);
        markFormGroupTouched(this.formAuto);
        return;
      }

      this.loading.salvando = true;
      this.unidadesMedida.forEach((r: any) => {
        if (r.id === this.form.controls.unidadeMedidaID.value) {
          this.form.controls.unidade.setValue(r.unidade);
        }
      });

      if (!this.novoCadastro) {
        if (this.codigoEmUso && this.itemInicial && this.itemInicial.referenciaItem != this.form.value.referenciaItem) {
          Swal({
            title: 'Salvar edição?',
            text: 'O código informado já está sendo utilizado em outro produto.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
          }).then(async (result) => {
            if (result.value) {
              const itemData = await this.editarProduto();
              this.salvarFotosProduto(itemData);
            } else {
              this.loading.salvando = false;
            }
          });
        } else {
          const itemData = await this.editarProduto();
          this.salvarFotosProduto(itemData);
        }
      } else if (this.codigoEmUso) {
        Swal({
          title: 'Cadastrar mesmo assim?',
          text: 'O código informado já está sendo utilizado em outro produto.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
        }).then(async (result) => {
          if (result.value) {
            const itemData = await this.cadastrarNovoProduto();
            this.salvarFotosProduto(itemData);
          } else {
            this.loading.salvando = false;
          }
        });
      } else {
        const itemData = await this.cadastrarNovoProduto();
        this.salvarFotosProduto(itemData);
      }
    }
  }

  async cadastrarNovoProduto() {
    return new Promise((resolve) => {
      this.itensService.create(this.form.value)
        .pipe(finalize(() => this.loading.salvando = false))
        .subscribe(async res => {
          const postOcupacoesAgenda = {
            itemId: res.generatedId,
            horariosPorData: this.horariosForm.value.horariosPorData,

          };

          if (!this.id && res.generatedId) {
            this.id = res.generatedId;
          }

          if (this.comercioVeiculos) {
            this.loading.salvando = true;
            if (this.formAuto.valid) {
              await lastValueFrom(this.autosService.salvarAuto(this.formAuto.value, res.generatedId));
              this.loading.salvando = false;
            }
          }

          if (this.listReducoesICMSInterestaduais.length > 0) {
            const obj = {
              produtoId: this.id,
              reducoes: this.listReducoesICMSInterestaduais,
            };
            await lastValueFrom(this.reducoesICMSInterestaduaisService.addOrUpdate(obj));
          }

          this.salvaOcupacaoAgendaCadastrar(postOcupacoesAgenda, res);
          resolve(postOcupacoesAgenda);
          return;

        },
          error => {
            this.errors = error.msg.errors;
            resolve({});
            return;
          });
    });
  }

  salvaOcupacaoAgendaCadastrar(postOcupacoesAgenda: any, res: any) {
    return new Promise((resolve) => {
      this.ocupacaoAgendaService.salvarMultiplos(postOcupacoesAgenda).subscribe({
        complete: () => {
          this.loading.horarios = false;

          if (this.cadastroFactory) {
            res.itemId = res.generatedId;
            this.finalizeFactory(res);
          } else {
            this.showFeedback(`Registro inserido com sucesso! <br> Código: ${res.referenciaItem}`);
          }

          resolve({});
          return;
        }
      });
    });
  }

  salvaOcupacaoAgendaEditar(postOcupacoesAgenda: any, res: any) {
    return new Promise((resolve) => {
      this.ocupacaoAgendaService.salvarMultiplos(postOcupacoesAgenda).subscribe({
        complete: () => {
          this.errors = null;
          this.loading.horarios = false;

          if (postOcupacoesAgenda.itemId) {
            if (this.cadastroFactory) {
              res.itemId = res.id;
              this.finalizeFactory(res);
            } else {
              this.showFeedback('Registro atualizado com sucesso!');
            }
          }

          resolve({});
          return;
        }
      });
    });
  }

  async buscarDimCloudRenavam() {
    const renavamDigitado = this.formAuto.get('renavam').value;

    if (!renavamDigitado) {
      this.messageService.error('Renavam não informado. Consulta na Dim Cloud necessita de um renavam válido.', 8000);
      return;
    }

    const auto = await firstValueFrom(this.autosService.GetByRenavam(renavamDigitado));
    if (!auto) {
      this.messageService.error('Renavam não encontrada na Dim Cloud. Digite os dados do veículo.', 8000);
      return;
    }

    auto.id = 0;
    this.formAuto.patchValue(auto);
  }

  async buscarDimCloudPlaca() {
    const placaDigitado = this.formAuto.get('placa').value;
    const estadoSelecionado = this.formAuto.get('estadoId').value;

    if (!placaDigitado) {
      this.messageService.error('Placa não informada. Consulta na Dim Cloud necessita de uma placa válida.', 8000);
      return;
    }

    if (!estadoSelecionado) {
      this.messageService.error('Estado não informado. Consulta na Dim Cloud necessita de um estado selecionado.', 8000);
      return;
    }

    const auto = await firstValueFrom(this.autosService.GetByPlaca(placaDigitado, estadoSelecionado));
    if (!auto) {
      this.messageService.error('Placa não encontrada no Dim Cloud');
      return;
    }

    auto.id = 0;
    this.formAuto.patchValue(auto);
  }

  async editarProduto() {
    if (this.comercioVeiculos) {
      if (this.formAuto.valid) {
        await lastValueFrom(this.autosService.salvarAuto(this.formAuto.getRawValue(), this.form.get('id').value));
      }
    }

    return new Promise((resolve) => {
      this.itensService.update(this.form.value)
        .pipe(finalize(() => this.loading.salvando = false))
        .subscribe(async response => {
          const postOcupacoesAgenda = {
            itemId: response.id,
            horariosPorData: this.horariosForm.value.horariosPorData
          };

          if (this.listReducoesICMSInterestaduais.length > 0) {
            const obj = {
              produtoId: response.id,
              reducoes: this.listReducoesICMSInterestaduais,
            };

            await lastValueFrom(this.reducoesICMSInterestaduaisService.addOrUpdate(obj));
          }

          await this.salvaOcupacaoAgendaEditar(postOcupacoesAgenda, response);
          resolve(postOcupacoesAgenda);
          return;
        },
          error => {
            this.errors = error.msg.errors;
            resolve({});
            return;
          });
    });
  }

  async excluir(id: number) {
    this.loading.deletando = true;

    try {
      await lastValueFrom(this.itensService.delete(id));
      this.showFeedback('Registro excluído com sucesso!');
    } catch (response) {
      if (response.status === 506) {
        this.inativarExcluido();
      } else {
        this.errors = response.error ? response.error.msg.errors : ['Ocorreu um erro desconhecido'];
      }
    } finally {
      this.loading.deletando = false;
    }
  }

  modalAlmoxarifadoClosed(id) {
    this.modalSubscription.unsubscribe();
    this.carregaAlmoxarifados();
    setFieldFormValue(this.form, 'almoxarifadoPadraoId', id);
  }

  modalLinhaProdutoClosed(id) {
    this.modalSubscription.unsubscribe();
    this.carregaLinhaProdutos();
    setFieldFormValue(this.form, 'linhaId', id);
  }

  modalNCMClosed(id) {
    this.modalSubscription.unsubscribe();
    if (id) {
      this.loading.classificacaoFiscal = true;
      this.classificacoesService.GetIdByNCM(id)
        .subscribe(response => {
          if (response) {
            this.form.controls.classificacaoFiscalID.setValue(parseInt(response));
            this.loading.classificacaoFiscal = false;
          } else {
            const ncm = JSON.stringify({ id: null, classificacaoFiscal: id, descricao: id });
            this.classificService.postCadastroResumidotNcm(ncm)
              .subscribe(res => {
                id = res.generatedId || null;
                this.form.controls.classificacaoFiscalID.setValue(id);
                this.loading.classificacaoFiscal = false;
              }, (error) => {
                this.errors = error.msg.errors;
                this.loading.classificacaoFiscal = false;
              });
          }
        });
    }
  }

  modalTabelasPrecoClosed(id) {
    this.modalSubscription.unsubscribe();
    this.carregaTabelasPreco();
    this.tabelasPrecoSelecionada = id;
  }

  showFeedback(message: string) {
    this.voltar();
    this.messageService.success(message);
  }

  inativarExcluido() {
    this.buscaDadosProduto();

    if (this.form.controls.inativo.value === true) {
      Swal({
        title: 'O produto já está em uso e não pode ser excluido!'
      }).catch(Swal.noop);
    } else {
      Swal({
        title: 'Deseja inativar o produto?',
        text: 'O produto já está em uso e não pode ser excluido!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Inativar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.value) {

          this.form.controls.inativo.setValue(true);

          this.itensService.update(this.form.value)
            .subscribe(response => {
              if (response.id) {
                this.showFeedback('Registro atualizado com sucesso!');
              }
            },
              error => {
                Swal('Erro', 'Um erro oorreu ao tentar alterar o produto', 'error');
              });
        }
      });
    }
  }

  addForm(object) {
    Object.keys(this.form.controls).forEach(element => {
      if (this.form.get(element)) {
        if (this.form.get(element) instanceof FormArray) {
          const control = this.form.get('tabelasPrecoProduto') as FormArray;
          for (let i = control.length - 1; i >= 0; i--) {
            control.removeAt(i);
          }
          setArrayFormValue(this.form.get('tabelasPrecoProduto') as FormArray, object[element] || []);
        } else {
          this.form.get(element).setValue(object[element]);
        }
      }
    });
  }

  modalClosed(item) {
    this.modalSubscription.unsubscribe();
    this.form.get('aliquotaicmsid').setValue(item);
    this.carregaAliquotaIcms();
  }

  verificaBloqueio() {
    if (this.campoAtual.campo === 'aliquotaicmsid' && this.campoAtual.value != null
      && this.campoAtual.value !== undefined && this.campoAtual.value !== 0) {
      return true;
    }
    return false;
  }
  aliquotasSelect() {
    if (this.form.get('servicoProduto').value === 'P') {
      this.aliquotasSelecionadas = this.aliquotas;
    }
  }

  subscribeModal(modal: string) {
    switch (modal) {
      case 'aliquotaIcms':
        this.modalSubscription = this.abrirModal.closed.subscribe(this.modalClosed.bind(this));
        break;
      case 'almoxarifado':
        this.modalSubscription = this.abrirModal.closed.subscribe(this.modalAlmoxarifadoClosed.bind(this));
        break;
      case 'linhaProduto':
        this.modalSubscription = this.abrirModal.closed.subscribe(this.modalLinhaProdutoClosed.bind(this));
        break;
      case 'ncmCloud':
        this.modalSubscription = this.abrirModal.closed.subscribe(this.modalNCMClosed.bind(this));
        break;
      case 'tabelasPreco':
        this.modalSubscription = this.abrirModal.closed.subscribe(this.modalTabelasPrecoClosed.bind(this));
        break;
    }
  }

  carregaTabelasPreco() {
    this.loading.tabelasPreco = true;
    this.tabelasPrecoService.get()
      .pipe(finalize(() => this.loading.tabelasPreco = false))
      .subscribe(response => {
        this.tabelasPrecosCadastradas = response;
        this.atualizaListaTabelasPrecosDisponiveis();
      });
  }

  async carregaAuto() {
    const autoID = this.form.get('autoID').value;
    if (autoID) {
      const auto = await lastValueFrom(this.autosService.GetById(autoID));
      setFormValue(this.formAuto, auto);
    }
  }

  atualizaListaTabelasPrecosDisponiveis() {
    this.tabelasPrecoDisponiveis = [];
    this.tabelasPrecosCadastradas.forEach(element => {
      if (this.tabelasPrecosGrid.find(value => value.tabelasPrecoId === element.id) === undefined) {
        this.tabelasPrecoDisponiveis.push(element);
      }
    });
  }

  atualizaArraysClone() {
    [...((this.form.get('tabelasPrecoProduto') as FormArray).value),
    ...((this.form.get('itensComposicao') as FormArray).value)]
      .forEach(x => {
        x.id = 0;
      });
  }

  vincular() {
    const tabela = this.tabelasPrecosCadastradas.find(value => value.id === this.tabelasPrecoSelecionada);
    if (!tabela) {
      this.tabelasPrecoError = 'Selecione uma tabela de preço.';
      return;
    }
    if (this.tabelasPrecoSelecionadaPreco <= 0) {
      this.tabelasPrecoError = 'Informe o preço deste item para esta tabela de preço.';
      return;
    }
    this.tabelasPrecoError = null;

    (this.form.get('tabelasPrecoProduto') as FormArray).insert(0, new FormControl({
      id: 0,
      tabelasPrecoId: tabela.id,
      preco: this.tabelasPrecoSelecionadaPreco,
      tabelasPreco: tabela
    }));
    this.atualizaListaTabelasPrecosDisponiveis();
    this.tabelasPrecoSelecionada = null;
    this.tabelasPrecoSelecionadaPreco = null;
  }

  removerVinculo(id: number) {
    const data = (this.form.get('tabelasPrecoProduto') as FormArray);
    const index = data.controls.findIndex(x => x.value.id === id);
    data.removeAt(index);
    this.atualizaListaTabelasPrecosDisponiveis();
  }

  clickHelpTabelaPreco() {
    this.abrirModal.abrir('exibirVideo', { video: 'CadastroTabelaPreco', time: this.tempoVideo, ocultarExibirNovamente: true });
  }

  get tabelasPrecosGrid() {
    return (this.form.get('tabelasPrecoProduto') as FormArray).value || [];
  }

  salvarHorarios(mostrarMensagem = true) {
    return new Promise((resolve, reject) => {
      this.loading.horarios = true;
      const postOcupacoesAgenda = {
        itemId: this.id,
        horariosPorData: this.horariosForm.value.horariosPorData
      };

      this.ocupacaoAgendaService.salvarMultiplos(postOcupacoesAgenda)
        .subscribe(res => {
          if (mostrarMensagem) {
            this.messageService.success('Agenda salva com sucesso!', 5000);
          }
        }, error => {
          if (mostrarMensagem) {
            this.messageService.success('Ocorreu um erro ao salvar a agenda!', 5000);
          }
        }, () => {
          this.horariosForm.markAsPristine();
          this.loading.horarios = false;
          resolve({});
        });
    });
  }

  calcularHorarios() {
    this.loading.horarios = true;
    const intervalo = this.form.get('cargaMinutosAgenda').value;
    (this.data as Date).setHours(0, 0, 0, 0);

    if (intervalo && this.data) {
      this.ocupacaoAgendaService.getOcupacoesByDate({ itemId: this.id, data: this.data }).subscribe(res => {
        const formGroup = new FormGroup({
          data: new FormControl(this.data),
          horarios: new FormArray([])
        });

        this.calcularIntervalos(intervalo).then((intervalos: Array<string>) => {
          intervalos.forEach((horario, i) => {
            const clienteId = !this.isNullOrUndefined(res.filter(o => o.periodo === horario)[0]) ? res.filter(o => o.periodo === horario)[0].clienteID : null;
            const horarioGroup = new FormGroup({
              itemId: new FormControl(this.id),
              periodo: new FormControl(horario),
              clienteId: new FormControl(clienteId)
            });

            (formGroup.get('horarios') as FormArray).push(horarioGroup);
          });

          const horariosPorData = this.horariosForm.get('horariosPorData') as FormArray;
          horariosPorData.value.forEach((x, i) => {
            if (x.data === this.data) {
              horariosPorData.removeAt(i);
              horariosPorData.push(formGroup);
            }
          });

          if (horariosPorData.value.filter(x => x.data === this.data).length === 0) {
            (this.horariosForm.get('horariosPorData') as FormArray).push(formGroup);
          }

          setTimeout(() => {
            this.loading.horarios = false;
          });
        });
      });
    } else {
      this.loading.horarios = false;
    }
  }

  formatarHorario(horario) {
    const hora = Math.floor(horario / 60);
    const minutos = ((horario / 60 % 1) * 60).toFixed(0);
    return hora.toString().padStart(2, '0') + ':' + minutos.toString().padStart(2, '0');
  }

  dateChange() {
    this.horariosForm.markAsPristine();
    this.calcularHorarios();
  }

  async calcularIntervalos(base) {
    const intervalos = [];

    return new Promise((resolve) => {
      const deltaHora = this.horarioFinal - this.horarioInicial;

      const numHorarios = Math.floor(deltaHora / base);

      for (let i = 0; i <= numHorarios; i++) {
        const horario = (this.horarioInicial + base * i);

        if ((this.horarioInicial + base * i) !== this.horarioFinal) {
          intervalos.push(horario);
        }

        if (i === numHorarios) {
          resolve(intervalos);
        }
      }
    });
  }

  lancarEstoque() {
    this.estoqueForm = {
      'almoxarifadoId': this.form.get('almoxarifadoPadraoId'),
      'unidadeMedidaId': this.form.get('unidadeMedidaID'),
      'quantidade': this.form.get('saldoInicialEstoque'),
      'motivoMovimentacaoEstoqueID': this.form.get('motivoMovimentacaoEstoqueID')
    };

    this.abrirModal.abrir('lancarEstoque', this.estoqueForm);
  }

  createViewItensComposicao(itemEdicao = null, index = null) {
    this.itensComposicaoContainer.clear();

    if (this.itensComposicaoContainer.length === 0) {
      const factory = this.resolver.resolveComponentFactory(ItensComposicaoComponent);

      this.itensComposicaoComponentRef = this.itensComposicaoContainer.createComponent(factory);

      if (itemEdicao) {
        this.itensComposicaoComponentRef.instance.itemEdicao = itemEdicao;
      }

      if (this.id) {
        this.itensComposicaoComponentRef.instance.produtoID = this.id;
      }

      this.itensComposicaoComponentRef.instance.formFinished.subscribe(item => {
        if (item) {
          if (!itemEdicao) {
            (this.form.get('itensComposicao') as FormArray)
              .insert((this.form.get('itensComposicao') as FormArray).length, new FormControl(item));
          } else {
            (this.form.get('itensComposicao') as FormArray).at(index).setValue(item);
          }
        }

        this.itensComposicaoComponentRef.destroy();
      });
    }
  }

  removerItemFilho(row) {
    (this.form.get('itensComposicao') as FormArray).removeAt(row);
  }

  replicarHorario(horario) {
    this.salvarHorarios(false).then(() => {
      this.modalSubscription = this.abrirModal.closed.subscribe(this.replicarHorarioClosed.bind(this));
      this.abrirModal.abrir('replicaHorariosAgenda', { itemId: this.id, data: this.data, ...horario });
    });
  }

  replicarHorarioClosed() {
    this.calcularHorarios();
    this.modalSubscription.unsubscribe();
  }

  //Função change do checkbox de código sequencial
  changeCheckCodigoSequencial($event: any) {
    const isChecked = $event.target.checked;
    if (isChecked) {
      this.form.get('referenciaItem').setValue('');
      this.codigoEmUso = false;
    }
  }

  async changeInputCodigo() {
    if (!this.novoCadastro && this.itemInicial && this.itemInicial.referenciaItem == this.form.value.referenciaItem) {
      return;
    }

    const codigo = this.form.get('referenciaItem').value;
    if (!codigo || codigo.trim() === '') {
      return;
    }

    try {
      this.codigoEmUso = await this.itensService.verificaCodigoItem(codigo, this.id).toPromise();
      if (this.codigoEmUso) {
        this.messageService.warning(`Código "${codigo}" já em uso.`, 5000, 'Atenção');
      } else {
        this.messageService.clearAll();
      }
    } catch (err) {
      console.error(err);
      this.messageService.error(`Falha temporária ao consultar disponibilidade do código "${codigo}".`, 5000);
      this.codigoEmUso = false;
    }
  }

  tratarStringXml(campoForm: string, event: any) {
    const value = tratarStringXml(event.target.value);
    this.form.get(campoForm).setValue(value);
  }

  tratarObservacoes(event: any) {
    const value = (event.target.value || '')
      // eslint-disable-next-line no-control-regex
      .replace(/[^\x0A\x0D\x20-\xFF]/gm, '')
      .replace(/[\xA0\xAD]/gm, '')
      .trim();
    this.form.get('observacoes').setValue(value);
  }

  aliquotaIcmsSelectLabel(item: IAliquotaICMS) {
    if ((item.percentualRedutorICMS || 0) > 0) { return `${item.aliquotaICMS}% - Redução ${item.percentualRedutorICMS || 0}%`; }

    return `${item.aliquotaICMS}%`;
  }

  habilitaCropper() {
    this.enviarImagem = true;
    this.mostraBotoesProduto = false;
  }

  voltarGaleria() {
    this.enviarImagem = false;
    this.mostraBotoesProduto = true;
    this.imagemParaEditar = undefined;
    this.imageCropperImage = '';
    this.imageCropperImageType = '';
    this.canvasRotation = 0;
    this.transform = {};
  }

  configuraItensFotos(itensFotos: any) {
    if (!itensFotos.length) {
      this.enviarImagem = true;
      return;
    }

    const favorita = itensFotos.find(foto => foto.favorita);
    if (!favorita) {
      itensFotos[0].favorita = true;
    }
    this.itensFotos = itensFotos;
    if (favorita) {
      this.favoritarFotoProduto(favorita.nome);
    }
  }

  slug(str: string) {
    // Convert to lowercase and trim whitespace
    const slug = str.toLowerCase().trim();

    // Remove non-alphanumeric characters using regular expression
    const sanitizedSlug = slug.replace(/[^a-z0-9\s]/g, '');

    // Replace spaces with hyphens
    const finalSlug = sanitizedSlug.replace(/\s+/g, '-');

    return finalSlug;
  }

  atualizaFotosProduto(data: any) {
    this.messageService.info('A imagem será armazenada apenas após salvar o produto.', 5000, 'Informação');
    if (this.imagemParaEditar) {
      const indexImagem = this.itensFotos.findIndex(foto => foto.id == this.imagemParaEditar.id);
      this.imagemParaEditar = undefined;
      const novaImagem = this.itensFotos[indexImagem];
      const newItensFotos = this.itensFotos;
      newItensFotos[indexImagem] = {
        ...novaImagem,
        src: data,
        srcBlob: this.dataURLtoFile(data, novaImagem.nome),
      };
      this.itensFotos = Object.assign([], newItensFotos);
    } else {
      const jaTemImagem = (this.itensFotos && this.itensFotos.length >= 1) || false;
      const nome = `file_${uuidv4()}.${this.imageCropperImageType || 'png'}`;
      const blob = this.dataURLtoFile(data, nome);
      const novaFoto = {
        alt: nome,
        src: data,
        srcBlob: blob,
        nome: nome,
        favorita: !jaTemImagem,
        mimeType: this.imageCropperImageType || 'png',
        descricao: ''
      };
      this.itensFotos.push(novaFoto);
    }
    this.enviarImagem = false;
    this.mostraBotoesProduto = true;
    this.imageCropperImage = '';
    this.imageCropperImageType = '';
    this.canvasRotation = 0;
    this.transform = {};
  }

  dataURLtoFile(dataurl, filename) {
    let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    const blob = new Blob([u8arr], { type: 'png' });
    return blob;
  }

  getMimeTypeFromBase64(imageBase64: string) {
    return imageBase64.split(':')[1].split(';')[0].split('/')[1];
  }

  handleGaleryOnEdit(data: any) {
    const image = this.itensFotos.find(foto => foto.id == data);
    if (image && image.id) {
      this.itensService.baixarFotoProduto(image.id)
        .subscribe(response => {
          const reader = new FileReader();
          reader.onload = () => {
            const base64String = reader.result;
            this.imagemParaEditar = {
              ...image,
              src: base64String
            };
            this.imageCropperImage = base64String;
            this.imageCropperImageType = this.getMimeTypeFromBase64(base64String.toString());
            this.enviarImagem = true;
          };
          reader.readAsDataURL(response);
        });
    } else {
      this.imagemParaEditar = image;
      this.imageCropperImage = image.src;
      this.imageCropperImageType = this.getMimeTypeFromBase64(image.src);
      this.enviarImagem = true;
    }
  }

  handleGaleryOnFavorite(data: any) {
    this.favoritarFotoProduto(data);
  }

  handleGaleryOnDelete(data: any) {
    this.removerFotoProduto(data);
  }

  handleGaleryOnRevert(data: any) {
    this.reverterFotoProduto(data);
  }

  removerFotoProduto(imagemId: any) {
    this.itensFotos = this.itensFotos.map(foto => {
      if (foto.id != imagemId) { return foto; }

      foto.removida = true;
      return foto;
    });
  }

  reverterFotoProduto(imagemId: any) {
    this.itensFotos = this.itensFotos.map(foto => {
      if (foto.id != imagemId) { return foto; }

      foto.removida = false;
      return foto;
    });
  }

  favoritarFotoProduto(imagemNome: any) {
    const novaFavorita = { ...this.itensFotos.find(foto => foto.nome == imagemNome), favorita: true };
    this.itensFotos = this.itensFotos.filter(foto => foto.nome != imagemNome).map(foto => { return { ...foto, favorita: false }; });
    this.itensFotos.unshift(novaFavorita);
  }

  get estadoEmpresa() {
    return this.unidadesEmpresa ? this.unidadesEmpresa.cidade.estado.siglaEstado : null;
  }

  async changedCstPisCofins(campo: 'pis' | 'cofins', cst: { id: string }) {
    if (cst.id === '01' && (this.unidadesEmpresa.crt == 2 || this.unidadesEmpresa.crt == 3) && !this.form.get(campo).value) {
      try {
        this.loading[campo] = true;

        const aliquotas = await this.itensService.buscarAliquotasPISCOFINS().toPromise();
        if (aliquotas) {
          const valor = campo === 'pis' ? aliquotas.aliquotaPIS : aliquotas.aliquotaCOFINS;
          this.form.get(campo).setValue(valor);
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading[campo] = false;
      }
    }
  }

  fileChangeEvent(files): void {
    if (files.length !== 0) {
      const file = files[0];

      const [info, type] = file.type.split('/');
      if (info !== 'image') {
        return;
      }
      this.imageCropperImageType = type;

      const reader = new FileReader();
      reader.onload = e => this.imageCropperImage = reader.result;
      reader.readAsDataURL(file);
    }
  }

  async cropImage() {
    const cropped = await this.imageCropper.crop('base64');
    this.atualizaFotosProduto(cropped.base64);
  }

  imageLoaded() {
    const overlay = document.getElementsByClassName('overlay')[0] as HTMLElement;

    if (!overlay || !overlay.parentElement || !overlay.parentElement.parentElement || overlay.parentElement.parentElement.nodeName != 'IMAGE-CROPPER') {
      return;
    }

    // WORKAROUND
    // Remove a propriedade outline default do plugin que causa bug visual na edição da imagem.
    // Talvez seja devido a versão ser antiga.
    const overlayStyle = overlay.style as CSSStyleDeclaration;
    overlayStyle.outline = 'none';
  }

  rotateRight() {
    this.canvasRotation++;
    this.flipAfterRotate();
  }

  rotateLeft() {
    this.canvasRotation--;
    this.flipAfterRotate();
  }

  flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH
    };
  }

  setFormValidators() {
    this.form.setValidators([this.validaValoresGLP()]);
  }

  private validaValoresGLP(): ValidatorFn {
    return (c: FormGroup): ValidationErrors => {
      if (this.icmsMonoDisabled) {
        return;
      }
      const controlCodigoANP = c.get('codigoANP');
      const controlGLP = c.get('combGLP');
      const controlpGNn = c.get('comb_pGNn');
      const controlpGNi = c.get('comb_pGNi');
      const controlpGLP = c.get('comb_pGLP');

      controlpGNn.setErrors(null);
      controlpGNi.setErrors(null);
      controlpGLP.setErrors(null);

      if (controlGLP.value === 1 || controlGLP.value === 2 || !controlCodigoANP.value) {
        return null;
      }

      const pGNn = roundCorrectly(controlpGNn.value || 0, 2).toNumber();
      const pGNi = roundCorrectly(controlpGNi.value || 0, 2).toNumber();
      const pGLP = roundCorrectly(controlpGLP.value || 0, 2).toNumber();

      const sum = roundCorrectly(pGNn + pGNi + pGLP || 0, 2).toNumber();
      if (sum !== 100) {
        const message = 'Os percentuais precisam somar 100%. Percentual total atual: ' + sum + '%';
        controlpGNn.setErrors({ custom: { message } });
        controlpGNi.setErrors({ custom: { message } });
        controlpGLP.setErrors({ custom: { message } });

        return {};
      }

      return null;
    };
  }

  getSiglaEstado(id) {
    if (!this.estadosMap || this.estadosMap.length === 0) {
      return null;
    }

    return this.estadosMap.find(x => x.id === id).siglaEstado;
  }

  salvarReducao() {
    markFormGroupTouched(this.formReducao);
    if (this.formReducao.invalid) {
      return;
    }

    // Edição
    if (this.indexReducao !== null) {
      this.listReducoesICMSInterestaduais.splice(this.indexReducao, 1);
      this.indexReducao = null;
    }

    this.listReducoesICMSInterestaduais.push(this.formReducao.value);
    this.listReducoesICMSInterestaduais.sort((a, b) => {
      if (!a.id && !b.id) return 0;
      if (!a.id || a.id === 0) return 1;
      if (!b.id || b.id === 0) return -1;
      return a.id - b.id;
    });
    this.cancelarEdicao();
  }

  editarReducao(row, index) {
    this.loading['editando'] = true;

    this.indexReducao = index;
    this.formReducao.get('id').setValue(row.id);
    this.formReducao.get('estadoId').setValue(row.estadoId);
    this.formReducao.get('percentualRedutorICMS').setValue(row.percentualRedutorICMS);
    this.formReducao.get('observacoes').setValue(row.observacoes);
  }

  cancelarEdicao() {
    this.formReducao.reset();
    this.loading['editando'] = false;
  }

  handleCombGLPChange() {
    if (this.icmsMonoDisabled) {
      return;
    }
    // Seleciona ICMS02 caso o tipoCombustível for inválido para o tipo do combGLP. O find abaixo representa um CST inválido para o combGLP selecionado.
    // Conferir 'types' da estrutura de opções.
    const tipoCombustivelForm = this.form.get('tipoCombustivel');
    if (!tipoCombustivelForm.value) {
      tipoCombustivelForm.setValue(this.icmsMonoCSTsOptionsFilter[0].value);
    }

    const icmsMonoCSTsOptionsValid = this.icmsMonoCSTsOptionsFilter.find(item => item.value === tipoCombustivelForm.value);
    if (!icmsMonoCSTsOptionsValid) {
      tipoCombustivelForm.setValue(this.icmsMonoCSTsOptionsFilter[0].value);
    }
  }

  async removerReducao(index) {
    this.loading['excluindo'] = true;
    const result = await Swal({
      title: 'Deseja mesmo excluir essa redução?',
      text: 'A redução será excluída ao salvar o produto',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar'
    });

    if (!result.value) {
      this.loading['excluindo'] = false;
      return;
    }

    this.listReducoesICMSInterestaduais.splice(index, 1);
    this.loading['excluindo'] = false;
    this.loading['editando'] = false;
  }

  async buscarReducoesVinculadas() {
    if (!this.id) {
      return;
    }

    try {
      this.listReducoesICMSInterestaduais = await lastValueFrom(this.reducoesICMSInterestaduaisService.obterPorItemId(this.id));
    } catch (error) {
      console.error(error);
    }
  }

  @HostListener('document:keydown.enter', ['$event'])
  preventEnterSubmit(event: KeyboardEvent) {
    const activeElement = document.activeElement as HTMLElement;
    if (activeElement && activeElement.tagName === 'INPUT') {
      event.preventDefault();
    }
  }

  async carregaCodigoCreditoPresumido() {
    try {
      this.loading['codigosCreditoPresumido'] = true;
      this.codigosCreditoPresumido = await this.codigosBeneficiosFiscaisService.getCreditoPresumido().toPromise();
    } catch (error) {
      console.error(error);
    } finally {
      this.loading['codigosCreditoPresumido'] = false;
    }
  }

  get customDataCBenef() {
    if (!this.unidadesEmpresa || this.form.get('servicoProduto').value === 'S') {
      return null;
    }

    if ([1, 4].includes(this.unidadesEmpresa.crt)) {
      return { cst: 'SIMPLES' };
    } else {
      const csts = {
        [TipoDestaqueICMS.NORMAL]: null,
        [TipoDestaqueICMS.ISENTO]: '40',
        [TipoDestaqueICMS.NAO_TRIBUTADO]: '41',
        [TipoDestaqueICMS.SUSPENSO]: '50',
        [TipoDestaqueICMS.DIFERIDO]: '51',
      }

      const cst = csts[this.form.get('tipoDestaqueICMS').value] || null;
      return { cst: cst }
    }
  }

  override tituloPagina(pagina): string {
    if (this.dentroModal) {
      return null;
    }

    return this.id ? `Editar ${pagina}` : `Cadastrar ${pagina}`;
  }

  get loadingRelaciomanetos() {
    return this.loading['removendoRelacionamento'] || this.loading['adicionandoItemFornecedor'] || this.loading['itens'];
  }

  alteraOption(index) {
    this.itensFornecedor = [];
    this.selectOptions.opSelecionado = index;
    this.buscaItensFornecedor('', this.selectOptions.options[this.selectOptions.opSelecionado].value)
  }

  adicionarRelacionamento() {
    this.formItemFornecedor = new FormGroup({
      fornecedorId: new FormControl(null, [Validators.required]),
      itemFornecedorId: new FormControl(null, [Validators.required]),
    });

    this.adicionandoItemFornecedor = true;
  }

  cancelarAdicaoItemFornecedor() {
    this.formItemFornecedor.reset();
    this.adicionandoItemFornecedor = false;
  }

  getSelectedOption() {
    return this.selectOptions.options[this.selectOptions.opSelecionado].value;
  }

  async buscaItensFornecedor(filter: string, searchParam: string = null, merge: boolean = false) {
    const fornecedorId = this.formItemFornecedor.get('fornecedorId')?.value;
    if (!fornecedorId) {
      this.itensFornecedor = [];
      return;
    }

    const paramMap: Record<string, string> = {
      'Código': 'referenciaItem',
      'Descrição': 'nome',
      'EAN': 'cEAN',
      'Código Entrada': 'codigoEntrada',
    };
    searchParam = paramMap[searchParam] || 'nome';

    try {
      this.loading['itens'] = true;
      const page = (this.itensFornecedor.length / 20) + 1;

      const response = await firstValueFrom(
        this.itensFornecedoresService.getPaginado(page, filter, fornecedorId, searchParam)
      );

      this.itensFornecedor = merge
        ? mergeArray(this.itensFornecedor, response)
        : response;

      this.focusItensFornecedores();
    } catch (error) {
      console.error(error);
    } finally {
      this.loading['itens'] = false;
    }
  }

  focusItensFornecedores() {
    setTimeout(() => {
      this.itensFornecedoresSelect?.focus();
      this.itensFornecedoresSelect?.open();
    }, 100);
  }

  selectItensFornecedorDescricao(row: any): string {
    const searchParam = this.selectOptions.options[this.selectOptions.opSelecionado]?.value;

    const paramMap: Record<string, (row: any) => string> = {
      'Código': r => `${r.item?.referenciaItem ?? ''} - ${r.nome}`,
      'Descrição': r => `${r.nome}`,
      'EAN': r => `${r.item?.cEAN ?? ''} - ${r.nome}`,
      'Código Entrada': r => `${r.referenciaItem ?? ''} - ${r.nome}`,
    };

    const formatter = paramMap[searchParam] ?? (r => `${r.nome}`);
    return formatter(row);
  }

  async adicionarItemFornecedor() {
    markFormGroupTouched(this.formItemFornecedor);
    if (this.formItemFornecedor.invalid) {
      return;
    }

    this.loading['adicionandoItemFornecedor'] = true;
    try {
      const obj = {
        itemFornecedorId: this.formItemFornecedor.get('itemFornecedorId').value,
        itemId: this.id,
      }
      await lastValueFrom(this.itensService.vincularItemFornecedor(obj));
      this.cancelarAdicaoItemFornecedor();
      this.itensFornecedor = [];
      this.buscarItensFornecedoresItem();
    } catch (error) {
      console.error(error);
    } finally {
      this.loading['adicionandoItemFornecedor'] = false;
    }
  }

  async buscarItensFornecedoresItem() {
    try {
      this.loading['itensFornecedor'] = true;
      const itensFornecedores = await lastValueFrom(this.itensFornecedoresService.getItensByItemId(this.id));
      this.itemInicial.itensFornecedores = itensFornecedores;
    } catch (error) {
      console.error(error);
    } finally {
      this.loading['itensFornecedor'] = false;
    }
  }

  async removerRelacionamento(id: number) {
    const result = await Swal({
      title: 'Confirmar exclusão',
      text: 'Tem certeza que deseja remover este relacionamento?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, remover',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6'
    });

    if (result.value) {
      this.loading['removendoRelacionamento'] = true;
      try {
        await lastValueFrom(this.itensFornecedoresService.removerVinculoItemDim(id));
        this.buscarItensFornecedoresItem();
        Swal('Sucesso', 'Relacionamento removido com sucesso!', 'success');
      } catch (error) {
        console.error(error);
        Swal('Erro', 'Ocorreu um erro ao remover o relacionamento.', 'error');
      } finally {
        this.loading['removendoRelacionamento'] = false;
      }
    }
  }

  onChangeImpostosTab(ev: MatTabChangeEvent) {
    const { index, tab } = ev;
    switch (tab.textLabel) {
      case 'ICMS':
        scrollIntoView('aba-ICMS');
        break;
      case 'IPI':
        scrollIntoView('aba-IPI');
        break;
      case 'PIS/COFINS':
        scrollIntoView('aba-PIS/COFINS');
        break;
      default:
        break;
    }
    return;
  }

  buscaCstIBSCBS(search, item) {
    return `${item.cst} - ${item.descricao}`.toLowerCase().includes(search.toLowerCase());
  }

  buscaCClassTribIBSCBS(search, item) {
    return `${item.cClassTrib} - ${item.nome}`.toLowerCase().includes(search.toLowerCase());
  }

  async buscarIBSCBS() {
    const isServico = (this.form.get('servicoProduto')?.value ?? '') === 'S';

    if (isServico) {
      this.cstIBSCBS = await firstValueFrom(this.ibscbsService.buscarCst('nfs'));
      const cClassTrib = await firstValueFrom(this.ibscbsService.buscarCClassTrib());
      this.listaCClassTribIBSCBS = cClassTrib.filter(x => x.indNFSe);
    } else {
      this.cstIBSCBS = await firstValueFrom(this.ibscbsService.buscarCst('nfe'));
      const cClassTrib = await firstValueFrom(this.ibscbsService.buscarCClassTrib());
      this.listaCClassTribIBSCBS = cClassTrib.filter(x => x.indNFe);
    }

    this.cClassTribIBSCBS = this.listaCClassTribIBSCBS.filter(x => x.cst === this.form.get('cstIBSCBS').value);
  }

  get ind_gDif() {
    return this.cstIBSCBS.find(x => x.cst === this.form.get('cstIBSCBS').value)?.ind_gDif;
  }

  get impostosTabs() {
    const produto = this.form.get('servicoProduto').value === 'P';

    return [
      produto ? 'ICMS' : null,
      produto ? 'IPI' : null,
      produto ? 'PIS/COFINS' : null,
      !produto ? 'ISSQN' : null,
      'IBS/CBS',
    ].filter(x => x);
  }

  observarTema() {
    this.observer = new MutationObserver(() => {
      this.definirImagemTooltip();
    });

    this.observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });

    this.definirImagemTooltip();
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  definirImagemTooltip() {
    const theme = document.documentElement.getAttribute('data-theme');

    this.tooltipImagem = theme === 'dark'
      ? 'assets/images/tooltip-localizacao-dark.png'
      : 'assets/images/tooltip-localizacao.png';
  }
}
